import { useQuery } from "@tanstack/react-query";
import { getCallSettings } from "../actions/get-call-flow.action";
import { callFlowQueryKeys } from "../queries/call-flow.query";

export const useCallSettingsQuery = (companyId: number) => {
    const query = useQuery({
        queryKey: callFlowQueryKeys.byCompanyId(companyId),
        queryFn: () => getCallSettings(companyId),
    });
    return query;
};
